/**
 * Returns the base URL for Supabase Edge Function calls.
 *
 * During local backend iteration (`npm run dev:fn`), set
 * `NEXT_PUBLIC_SUPABASE_FUNCTIONS_URL=http://127.0.0.1:54321/functions/v1`
 * in `.env.local`. Every call site (server actions, streaming clients,
 * webhooks) routes through this helper, so one flag redirects all
 * function traffic to the local `supabase functions serve` runtime
 * while the DB / Auth continue to talk to prod.
 *
 * Production / preview builds leave the override unset and fall back to
 * prod's `/functions/v1` path.
 */
export function getEdgeFunctionsBase(): string {
  const override = process.env.NEXT_PUBLIC_SUPABASE_FUNCTIONS_URL?.replace(/\/$/, "")
  if (override) return override

  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL?.replace(/\/$/, "")
  return `${supabaseUrl}/functions/v1`
}

export function getEdgeFunctionUrl(name: string): string {
  return `${getEdgeFunctionsBase()}/${name}`
}
